
    import './styles.scoped.css';
    export default {
  "code-editor-refresh": "awsui_code-editor-refresh_1gl9c_o9i8a_158",
  "code-editor": "awsui_code-editor_1gl9c_o9i8a_158",
  "pane": "awsui_pane_1gl9c_o9i8a_700",
  "pane__close-container": "awsui_pane__close-container_1gl9c_o9i8a_711",
  "pane__list": "awsui_pane__list_1gl9c_o9i8a_716",
  "pane__table": "awsui_pane__table_1gl9c_o9i8a_723",
  "pane__item": "awsui_pane__item_1gl9c_o9i8a_729",
  "pane__cell": "awsui_pane__cell_1gl9c_o9i8a_729",
  "pane__item--highlighted": "awsui_pane__item--highlighted_1gl9c_o9i8a_743",
  "pane__location": "awsui_pane__location_1gl9c_o9i8a_764",
  "pane__description": "awsui_pane__description_1gl9c_o9i8a_764",
  "focus-lock": "awsui_focus-lock_1gl9c_o9i8a_779",
  "editor": "awsui_editor_1gl9c_o9i8a_823",
  "editor-refresh": "awsui_editor-refresh_1gl9c_o9i8a_853",
  "status-bar": "awsui_status-bar_1gl9c_o9i8a_858",
  "status-bar-with-hidden-pane": "awsui_status-bar-with-hidden-pane_1gl9c_o9i8a_867",
  "status-bar__left": "awsui_status-bar__left_1gl9c_o9i8a_871",
  "status-bar__right": "awsui_status-bar__right_1gl9c_o9i8a_878",
  "status-bar__language-mode": "awsui_status-bar__language-mode_1gl9c_o9i8a_882",
  "status-bar__cursor-position": "awsui_status-bar__cursor-position_1gl9c_o9i8a_882",
  "status-bar__cog-button": "awsui_status-bar__cog-button_1gl9c_o9i8a_888",
  "tab-list": "awsui_tab-list_1gl9c_o9i8a_893",
  "tab-button": "awsui_tab-button_1gl9c_o9i8a_898",
  "tab-button--refresh": "awsui_tab-button--refresh_1gl9c_o9i8a_931",
  "tab-button--warnings": "awsui_tab-button--warnings_1gl9c_o9i8a_934",
  "tab-button--active": "awsui_tab-button--active_1gl9c_o9i8a_943",
  "tab-button--disabled": "awsui_tab-button--disabled_1gl9c_o9i8a_959",
  "tab-button--divider": "awsui_tab-button--divider_1gl9c_o9i8a_992",
  "tab-button--errors": "awsui_tab-button--errors_1gl9c_o9i8a_999",
  "count": "awsui_count_1gl9c_o9i8a_1008",
  "text": "awsui_text_1gl9c_o9i8a_1011",
  "loading-screen": "awsui_loading-screen_1gl9c_o9i8a_1033",
  "error-screen": "awsui_error-screen_1gl9c_o9i8a_1034"
};
  